import { isNil } from "lodash";

export const labelOrNull = <T extends string>(
  input: { label: T } | null | undefined
): T | null => (isNil(input) ? null : input.label);
